export default function fetchCheckPix(paymentId) {
    return fetch(process.env.VUE_APP_API_ORIGIN + '/api/checkPix/' + paymentId, {
        method: 'GET'
    })
}